import CategoryPanel from './components/CategoryPanel';

const LOGO_IMAGE =
  'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/b02d261c94c70eb29694e4d94e5f7f25.png';

const options = [
  {
    path: '/gostilna',
    kicker: 'Restavracija · Domača kuhinja',
    title: 'Gostilna',
    description:
      'Tradicionalne slovenske jedi, domači okusi in toplina gostoljubja. Poglejte ponudbo, jedilnik in rezervirajte mizo.',
    cta: 'VSTOPI V GOSTILNO',
    icon: 'ri-restaurant-2-line',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/29f8a11afc46af1a93824a77eee0ece3.png',
    alt: 'Gostilna Marta – toplo vzdušje domače slovenske gostilne',
  },
  {
    path: '/sobe',
    kicker: 'Nastanitev · Prenočišča',
    title: 'Sobe in prenočišča',
    description:
      'Mirno okolje, udobne sobe in domač zajtrk. Poglejte vrste sob, opremo in pošljite povpraševanje za rezervacijo.',
    cta: 'POGLEJ SOBE',
    icon: 'ri-hotel-bed-line',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/5d867f2f3cafc4c2fe28665be2db15e4.png',
    alt: 'Gostilna Marta – udobna soba za prenočišče',
  },
];

export default function Welcome() {
  return (
    <div className="relative w-full min-h-screen bg-background-950">
      <header className="absolute top-0 left-0 right-0 z-20 flex flex-col items-center pt-7 md:pt-9 px-5 text-center pointer-events-none">
        <span className="pointer-events-auto">
          <img
            src={LOGO_IMAGE}
            alt="Gostilna Marta – logotip"
            title="Gostilna Marta – tradicionalna slovenska gostilna in prenočišča"
            className="h-10 md:h-14 w-auto object-contain"
          />
        </span>
        <p className="font-label text-[10px] md:text-xs tracking-extra-wide text-white/65 uppercase mt-3 md:mt-4">
          Izberite, kam želite
        </p>
      </header>

      <div className="flex flex-col lg:flex-row w-full min-h-screen">
        {options.map((option) => (
          <CategoryPanel key={option.path} {...option} />
        ))}
      </div>
    </div>
  );
}